import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const SWidget = styled.div`
    padding: 20px;
    display: flex;
    flex-flow: column;
    min-height: 300px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px;
`

export const SWidgetHeader = styled.div`
    margin-bottom: ${({ theme }) => theme.sizing.margin.m};
    display: flex;
    justify-content: space-between;
    align-items: center;
`
export const WidgetHeaderText = styled.div`
    padding: 10px 20px;
    display: flex;
    letter-spacing: 1%;
    font-weight: 300;
    font-size: 16px;
    font-family: ${({ theme }) => theme.font.name};
`
export const SWidgetBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`

export const SDisabledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    background: rgba(212, 212, 212, 0.5);
`

export const SLoadingIcon = styled(FontAwesomeIcon)`
    margin-top: 3px;
`

export const SWidgetActionButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
    gap: 10px;
`
